export type Changelog = {
  id: number;
  title: string;
  body: string | null;
  labels:
    | {
        id: number;
        name: ChangelogFilterByValue;
      }[]
    | [];
  state: string;
  closed_at: string;
  vendorDisplayName: string | undefined;
  vendorLink: string | undefined;
};

export enum ChangelogFilterByEnum {
  all = 'All',
  improvement = 'Improvement',
  // update = 'Update',
  bug_fix = 'Bug Fix',
  retailer_added = 'Retailer Added',
  retailer_fixed = 'Retailer Fixed',
  firefox = 'Firefox',
  safari = 'Safari',
}

export type ChangelogFilterByValue = keyof typeof ChangelogFilterByEnum;
